import { render, staticRenderFns } from "./formularioComponent.vue?vue&type=template&id=54939578&scoped=true"
import script from "./formularioComponent.vue?vue&type=script&lang=js"
export * from "./formularioComponent.vue?vue&type=script&lang=js"
import style0 from "./formularioComponent.vue?vue&type=style&index=0&id=54939578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54939578",
  null
  
)

export default component.exports